import * as yup from "yup";

export const shareFormSchema = yup.object({
  subscriptions: yup.array().of(yup.string()),
});
